import React, { useEffect } from 'react';
import './SupportPage.css';

const SupportPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="support-page">
      <div className="support-hero">
        <div className="container">
          <div className="support-content">
            <h1>Centro de Ventas y Soporte</h1>
            <p className="support-subtitle">
              Estamos aquí para ayudarte con cualquier pregunta o problema que puedas tener.
              Nuestro equipo de soporte está disponible para brindarte la mejor atención.
            </p>

            <div className="floating-arrows">
              <div className="arrow-to-whatsapp">
                <span>WhatsApp</span>
                <div className="flashing-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </div>
              <div className="arrow-to-chatwoot">
                <span>Chat Directo</span>
                <div className="flashing-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </div>
            </div>

            <div className="contact-info-section">
              <div className="contact-info-card">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-details">
                    <h3>Correos Electrónicos</h3>
                    <div className="email-list">
                      <p>andres.gutierrez@distracker.com.mx</p>
                      <p>gerencia@distracker.com.mx</p>
                    </div>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="contact-details">
                    <h3>WhatsApp</h3>
                    <p>+52 55 6207 6934</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
